import { AutoComplete } from "antd";
import React from "react";
import { FormLabel } from "../Components/FormLabel";
import { FormInputsProps, RenderContextType } from "../../../types/formTypes";
import { print_when_component_is_rendered } from "../../../../utils/develop";
import { Group } from "../Components/Group";

interface ComponentsPropertiesProps {
    componentsProperties: FormInputsProps;
    renderContext: RenderContextType;
}

export const QAAutoComplete: React.FC<ComponentsPropertiesProps> = ({ componentsProperties, renderContext }) => {
    print_when_component_is_rendered(componentsProperties);

    return (
        <Group componentsProperties={componentsProperties} renderContext={renderContext}>
            <FormLabel componentsProperties={componentsProperties} required={false} renderContext={renderContext}>
                <AutoComplete placeholder={null} />
            </FormLabel>
        </Group>
    );
};
